
/**
 * Benefits TS class for the Benefits TCA-CE
 */
export class Benefits
{

}

document.addEventListener("DOMContentLoaded", () => {
  const blocks = document.querySelectorAll<HTMLElement>(".benefits .toggle-block");

  const getTallestSlideHeight = (sliderRoot: HTMLElement): number => {
    let tallest = 0;

    sliderRoot.querySelectorAll<HTMLElement>(".swiper-slide").forEach(slide => {
      const card = slide.firstElementChild as HTMLElement | null;

      const height = card
        ? card.getBoundingClientRect().height
        : slide.getBoundingClientRect().height;

      if (height > tallest) {
        tallest = height;
      }
    });

    return Math.ceil(tallest);
  };

  const updateSwiperHeight = (toggleBlock: HTMLElement) => {
    const sliderRoot = toggleBlock.closest<HTMLElement>("[slider]");
    if (!sliderRoot) return;

    const swiper = sliderRoot.querySelector<HTMLElement>(".swiper");
    if (!swiper) return;

    // Wait until the CSS has reacted to data-state="open" / "closed"
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const tallest = getTallestSlideHeight(sliderRoot);

        if (tallest > 0) {
          swiper.style.height = `${tallest + 10}px`;
        }
      });
    });
  };

  blocks.forEach(block => {
    const plusBtn = block.querySelector<HTMLElement>(".btn-plus");
    const minusBtn = block.querySelector<HTMLElement>(".btn-minus");

    plusBtn?.addEventListener("click", () => {
      block.dataset.state = "open";
      updateSwiperHeight(block);
    });

    minusBtn?.addEventListener("click", () => {
      block.dataset.state = "closed";
      updateSwiperHeight(block);
    });

    // Important for items that are initially open from Fluid
    updateSwiperHeight(block);
  });

  window.addEventListener("resize", () => {
    blocks.forEach(block => {
      updateSwiperHeight(block);
    });
  });
});